<template>
  <div class="tools-topbar-container">
    <!-- Popover Style -->
    <div v-if="displayMode === 'popover'" class="tools-popover-container">
      <Button @click="togglePopover" class="popover-trigger-btn" shape="round">
        <IconRenderer name="apps-outline" slot="icon-only" size="md"></IconRenderer>
      </Button>

      <Transition name="popover-fade">
        <div v-if="popoverOpen" class="popover-box" @click.stop>
          <ToolsGrid size="normal" :columns="4" @tool-click="togglePopover" />
        </div>
      </Transition>

      <!-- Backdrop for closing popover -->
      <div v-if="popoverOpen" class="popover-backdrop" @click="togglePopover"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import IconRenderer from '@/common/components/ui/icon/IconRenderer.vue';
import ToolsGrid from '@/layouts/components/ToolsGrid.vue';
import Button from '@/common/components/ui/button/Button.vue';

const displayMode = ref<'popover' | 'fabmenu'>('popover');
const fabOpen = ref(false);
const popoverOpen = ref(false);

// Determine display mode from environment variable
const modeFromEnv = import.meta.env.VITE_TOOLBOX_MENU_DISPLAY;
if (modeFromEnv === 'fabmenu') {
  displayMode.value = 'fabmenu';
} else {
  displayMode.value = 'popover';
}

const togglePopover = () => {
  popoverOpen.value = !popoverOpen.value;
};

// Close all menus when switching modes
watch(displayMode, () => {
  fabOpen.value = false;
  popoverOpen.value = false;
});
</script>

<style scoped>
.tools-topbar-container {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* Popover Style */
.tools-popover-container {
  position: relative;
}

.popover-trigger-btn {
  --padding-start: 8px;
  --padding-end: 8px;
}

.popover-trigger-btn ion-icon {
  font-size: 28px;
}

.popover-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.2);
}

.popover-box {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: var(--ion-background-color);
  border: 1px solid var(--ion-input-border-color);
  border-radius: 12px;
  box-shadow: var(--ion-box-shadow-hover);
  min-width: 320px;
  padding: 16px;
  z-index: 999;
}

/* Popover Transition */
.popover-fade-enter-active,
.popover-fade-leave-active {
  transition: all 0.3s ease;
}

.popover-fade-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.popover-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
